import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { defaultVenuesExportFieldNames } from "~pages/Venues/VenueListPage/constants/exportFields.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useExportVenues = () => {
  const { sport = "", organizationId = "" } = useParams();
  const request = useApi();

  return useMutation<DefaultOperationSuccessResponse, Error, Array<string>>({
    mutationFn: async (fieldNames: Array<string>) => {
      const body = {
        fieldNames: fieldNames || defaultVenuesExportFieldNames,
      };
      return await request(`${sport}/o/${organizationId}/venues/export`, {
        method: "POST",
        body,
      });
    },
  });
};
